"use strict";
require("./cod");
